// Turns an API error response into the text shown by screens that surface
// `(e as Error).message` directly. The API answers with `{ error: "<code>" }`,
// and HTTP/2 responses carry an empty statusText, so the old
// `${status} ${statusText}` message rendered as just "400 ".
const MESSAGES: Record<string, string> = {
  not_found: "対象が見つかりませんでした。",
  forbidden: "この操作を行う権限がありません。",
  unauthorized: "ログインし直してください。",
  too_large: "ファイルが大きすぎます（上限 10 MiB）。",
  body_too_large: "本文が長すぎます。",
  unsupported_mime: "この形式のファイルはアップロードできません。",
  file_required: "ファイルを選択してください。",
  invalid_slug: "slug の形式が正しくありません。",
  invalid_json: "リクエストの形式が正しくありません。",
  slug_taken: "その slug は既に使われています。",
  slug_mismatch: "入力した slug が一致しません。",
  email_taken: "そのメールアドレスは既に登録されています。",
  not_a_member: "このユーザーはプロジェクトのメンバーではありません。",
  last_owner_protected:
    "最後の owner は降格・削除できません。先に別のメンバーを owner にしてください。",
  cannot_delete_self: "自分自身は削除できません。",
  deploy_hook_not_configured: "デプロイフックの URL が設定されていません。",
  deploy_hook_fetch_failed: "デプロイフックの呼び出しに失敗しました。",
  ai_unavailable: "AI が利用できない設定になっています。",
  internal_error: "サーバーでエラーが発生しました。時間をおいて再度お試しください。",
};

export function apiErrorMessage(status: number, payload: unknown): string {
  if (payload && typeof payload === "object") {
    const error = (payload as { error?: unknown }).error;
    if (typeof error === "string") {
      return MESSAGES[error] ?? `エラーが発生しました（${error}）。`;
    }
    // @hono/zod-validator responds with { success: false, error: <ZodError> }.
    if (error && typeof error === "object") {
      return "入力内容が正しくありません。";
    }
  }
  if (status >= 500) return MESSAGES.internal_error!;
  return `エラーが発生しました（HTTP ${status}）。`;
}
